import { AlertTriangle, BadgeCheck, Building, FileText } from "lucide-react";

export const KindBadge = ({ kind }) => kind === "official" ? (
  <span data-testid="form-kind-official" className="inline-flex items-center gap-1 rounded-full border border-navy/20 bg-navy/5 px-2 py-0.5 text-[11px] font-medium text-navy"><Building className="h-3 w-3" /> Official agency form</span>
) : (
  <span data-testid="form-kind-template" className="inline-flex items-center gap-1 rounded-full border border-gold/50 bg-gold-light px-2 py-0.5 text-[11px] font-medium text-gold-dark"><FileText className="h-3 w-3" /> EVR template (not official)</span>
);

export const AnswerSheetBadge = ({ testId = "answer-sheet-badge" }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-900"><FileText className="h-3 w-3" /> Answer sheet only</span>
);

const LABELS = { verified: "Verified", outdated: "Outdated", unverified: "Not verified", needs_reverification: "Needs re-verification" };

export const VersionStatus = ({ v }) => v.usable ? (
  <span data-testid="version-status-verified" className="inline-flex items-center gap-1 text-xs text-emerald-700"><BadgeCheck className="h-3.5 w-3.5" /> Verified {v.verified_on}</span>
) : (
  <span data-testid="version-status-paused" className="inline-flex items-center gap-1 text-xs text-amber-800"><AlertTriangle className="h-3.5 w-3.5" /> {LABELS[v.status] || v.status}: paused</span>
);

export const ManualGuidanceNote = () => (
  <p data-testid="manual-guidance-note" className="rounded-md border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600">
    Manual guidance written by EVR from the official sources linked here. It may not fit your situation. <strong>AI help</strong> is available on each question: it only explains, can be wrong, and never fills in answers. You sign, certify and submit forms yourself. EVR never submits or signs anything.
  </p>
);
